import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type ThemeInitialtate = {
  dark: boolean;
};

const initialState: ThemeInitialtate = {
  // dark: true,
  dark: false,
};

export const themeSlice = createSlice({
  name: 'themeSlice',
  initialState,
  reducers: {
    themeToggle: (state) => {
      state.dark = !state.dark;
    },
    themePayloadToggle: (state, action: PayloadAction<boolean>) => {
      state.dark = action.payload;
    },
  },
});

export const { themePayloadToggle, themeToggle } = themeSlice.actions;
export default themeSlice.reducer;
